import {
  HYDRATION_COMPLETE,

  hydrateNext,
} from '../actions/hydration/orchestration';

import {
  hydrationFeatureSelector,
} from '../selectors/hydration/hydrationSelector';


import hydrationLoadOrder from '../actions/hydration/hydrationLoadOrder';

// this routing middleware needs to come earlier than the others that depend on it
export const dispatcherMiddleware = state => next => (action) => {
  if (action.type && action.type.includes(HYDRATION_COMPLETE)) {
    // HYDRATION_COMPLETE is dispatched by either the component or a timeout
    // action signifies hydration complete or forced to complete for that particular feature
    // We need to check to see the next feature has already been started possibly by a timeout
    // if not we need to initiate hydration for it
    const hydration = hydrationFeatureSelector(action.meta.feature)(state.getState());

    if (hydration) {
      if (!hydration.hydrated) {
        // redux needs to know
        next(action);
      }
      const loadNext = hydrationLoadOrder[action.meta.feature].next;
      if (loadNext) {
        const hydrationNext = hydrationFeatureSelector(loadNext)(state.getState());
        if (!hydrationNext) {
          const {
            feature,
            timeout,
          } = hydrationLoadOrder[loadNext];
          if (feature) {
            next(hydrateNext({
              feature,
              timeout,
            }));
          }
        }
      }
    }
  } else {
    next(action);
  }
};
